import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataDistributionChannel } from '../types/masterdata-entities';
import { ACTIVE_ONLY, keyName } from './shared';

export const MASTERDATA_DISTRIBUTION_CHANNEL =
  defineMasterdataEntity<MasterdataDistributionChannel>({
    name: 'distribution-channel',
    responseKey: 'distributionChannels',
    displayWith: (d) => keyName(d.key, d.name),
    defaultFilter: ACTIVE_ONLY,
    icon: 'fa-regular fa-route',
    title: 'Vertriebswegsuche',
    label: 'Vertriebsweg',
    placeholder: 'Vertriebsweg suchen...',
    columns: [
      {
        label: 'Vertriebsweg',
        type: 'entity',
        icon: 'fa-regular fa-route',
        value: (e) => keyName(e.key, e.name),
      },
      { label: 'Nr.', type: 'text', value: (e) => e.key },
      { label: 'Bezeichnung', type: 'text', value: (e) => e.name },
      { label: 'Aktiv', type: 'text', value: (e) => (e.active ? 'Ja' : 'Nein') },
    ],
  });
